import React from 'react';
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router'
import { reactLocalStorage } from 'reactjs-localstorage';
import { store } from '../index'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      reactLocalStorage.set('lastRoutePath', props.location.pathname);
      if (store.getState().auth.user) {
        return <Component {...props} />;
      }

      return <Redirect to="/login" />;
    }}
  />
)

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.object
}

PrivateRoute.defaultProps = {
  location: null
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/routes/PrivateRoute.js